import {
  BookOpenIcon,
  ClipboardCheckIcon,
  KeyRoundIcon,
  LanguagesIcon,
  PrinterIcon,
  type LucideIcon,
} from 'lucide-react'

export type IconName =
  | 'bookOpen'
  | 'clipboardCheck'
  | 'keyRound'
  | 'languages'
  | 'printer'

export const icons: Record<IconName, LucideIcon> = {
  bookOpen: BookOpenIcon,
  clipboardCheck: ClipboardCheckIcon,
  keyRound: KeyRoundIcon,
  languages: LanguagesIcon,
  printer: PrinterIcon,
}
